"use client";
import { motion } from 'framer-motion';

import { useNavigation } from '../../../Contexts/navigationContext';
import Heading from '../../Common/Heading';
import Content from './content';

const Index = () => {
  const { courseCurriculumRef } = useNavigation();
  return (
    <div className='bg-[#F8FAFC]' ref={courseCurriculumRef}>
      <div className='py-10 px-5 sm:py-[80px] sm:px-[120px] sm:space-y-10 space-y-5'>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <Heading text='Course Curriculum'/>
        </motion.div>
        <Content/>
      </div>
    </div>
  )
}

export default Index;
